<template>
  <div class="application" >
    <!-- 签署表单 失败/未申请 -->
    <div class="appl" 
        :class="[screenHeightNoChange ? 'appl2' : '']"
        v-if="show_re == 'not_apply' || show_re == 'failed'">

        <div class="form_box2410">
          <!-- :show-error="false" :show-error-message="false"  -->
          <van-form @submit="onSubmit" ref="ruleForm" 
          @failed="onFailed"
          >

          <div class="border"></div>

            <van-field
              :required="true"
              v-model="ruleForm.name"
              name="姓名"
              label="姓名"
              placeholder="姓名和身份证必须一致"
              :rules="rules.name"
            />
            <van-field
              :required="true"
              v-model="ruleForm.card"
              type="number"
              name="身份证号"
              label="身份证号"
              placeholder="请输入身份证号"
              :rules="rules.card"
            />

            <van-field
              :required="true"
              v-model="ruleForm.phone"
              name="手机号"
              label="手机号"
              readonly
              :rules="rules.phone"
            >
              <template #input>
                <div class="boxbox">
                  <a href="javascript:;" v-if="ruleForm.phone">{{ ruleForm.phone  }}</a>
                  <span v-else class="alink" @click="pageToPhone"> 请先绑定手机号 </span>

                </div>
              </template>
            </van-field>

            
                    
                                         
               

            <van-field
              :required="true"
              v-model="ruleForm.contact"
              name="微信号/qq号"
              label="微信号/qq号"
              placeholder="请填写微信号/qq号"
              :rules="rules.contact"
            />

            <van-field name="radio" label="性别" :rules="rules.sex" :required="true">
              <template #input>
                <van-radio-group v-model="ruleForm.sex" direction="horizontal">
                  <van-radio name="man">男</van-radio>
                  <van-radio name="women">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              :required="true"
              readonly
              clickable
              name="area"
              :value="ruleForm.loc"
              label="所在地"
              placeholder="点击选择省市"
              @click="showArea = true"
              :rules="rules.loc"
            />
            <van-popup v-model="showArea" position="bottom"
            >
              <van-area
                :area-list="areaList"
                @confirm="onConfirm"
                :columns-num="2"
                @cancel="showArea = false"
                :item-height="88"
              />
            </van-popup>

            <div class="border"></div>

            <van-field
              v-model="ruleForm.other"
              
              :required="true"
              rows="2"
              autosize
              label="其他平台账号名称"
              type="textarea"
              placeholder="如公众号、视频号、抖音、快手、微博、雪球等自媒体账号"
              :rules="rules.other"
            >
              <template #label>
                <div>其他平台<br>账号名称</div>
              </template>
            </van-field>


            <van-field name="radio" 
              :required="true"
              label="自媒体粉丝量" :rules="rules.fans">
              <template #input>
                <van-radio-group v-model="ruleForm.fans" direction="horizontal">
                  <van-radio name="less_than_1w">少于1万</van-radio>
                  <van-radio name="more_than_1w">超过1万</van-radio>
                </van-radio-group>
              </template>
            </van-field>


            <van-field name="uploader"
              label="" :rules="rules.fans_pic"
              :required="true"
              >
              <template #input>
                <div class="boxbox">
                  <h1>自媒账号的截图</h1>
                  <p>至少一张，最多三张</p>
                  <van-uploader v-model="ruleForm.fans_pic" :max-count="3" 
                   readonly
                   @click-upload="upload(3-ruleForm.fans_pic.length,'fans_pic')"
                   />
                </div>
              </template>
            </van-field>

            <div class="radio_box">
              <van-field name="radio" label="是否具备投顾资质" :rules="rules.vip"
              
              >
                <template #label>
                  <div>是否具备<br>投顾资质</div>
                </template>
                <template #input>
                  
                    <van-radio-group v-model="ruleForm.vip" direction="horizontal">
                      <van-radio name="yes">是</van-radio>
                      <van-radio name="no">否</van-radio>
                    </van-radio-group>
                
                  
                </template>
              </van-field>
            </div>

            <div class="border"></div>

            <van-field name="uploader2"
              label="" :rules="rules.id_pic"
              :required="true"
              >
              <template #input>
                <div class="boxbox">
                  <h1>身份信息</h1>
                  <p>请参照示例手持身份证拍照，信息清晰可见。<br>
                    格式要求：支持jpg.jpeg.png格式照片，大小不超过2M。</p>
                  <div class="img_box">
                    <div class="up">
                      <van-uploader v-model="ruleForm.id_pic" :max-count="1" 
                      readonly
                      @click-upload="upload(1-ruleForm.id_pic.length,'id_pic')"
                      />
                    </div>
                    <div class="pic_ex">
                      <p>示例：</p>
                      <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/sbid_card.png" />
                    </div>
                  </div>
                  
                </div>
              </template>
            </van-field>

            <van-field
            :label-class="'other'"
              v-model="ruleForm.desc"
              :required="true"
              rows="4"
              autosize
              label="个人简介"
              type="textarea"
              placeholder="请填写您的教育、职业、人生经历、以及现任职位、擅长的领域和技能及取得的成就。如果您有某些权威的认证证书或职业资质，将使您更容易获得并通过认证。注：所获奖项等需网络可查！"
              :rules="rules.desc"
              @focus="scrollFn(true)"
              @blur="scrollFn(false)"
            />

            <div class="border"></div>

            <div class="sb_p" @click="agree = !agree;">
              <svg v-show="!agree" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <rect x="2.5" y="2.5" width="17" height="17" rx="3.5" fill="white" stroke="#DCDCDC"/>
              </svg>
              <svg v-show="agree" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <rect x="2.5" y="2.5" width="17" height="17" rx="3.5" stroke="#DCDCDC"/>
                <path d="M6.32275 11.2668L9.02709 13.9711C9.41761 14.3616 10.0508 14.3616 10.4413 13.9711L15.8838 8.52856" stroke="#FF443D" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
              我已阅读并同意 <span @click.stop.prevent="page">《爱股票合作者服务规范》</span> 
            </div>

            <div class="btn">
              <van-button color="#FF443D" square block type="info" native-type="submit">签署协议</van-button>
            </div>

          </van-form>
            
        </div>
    </div>
    <!-- 签署结果 -->
    <!-- 审核中 -->
    <div class="appl_re" v-if="show_re == 'in_review'">
        <h1>签署协议已提交</h1>
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="77" viewBox="0 0 76 77" fill="none">
            <circle cx="38" cy="38.5" r="38" fill="url(#paint0_linear_18567_54224)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0761 66.8187C23.0971 66.8187 22.2131 66.2266 21.8308 65.3153L21.1286 59.9216C20.9093 59.3986 21.05 58.7993 21.4679 58.4196C22.9605 57.0641 23.7701 54.9572 23.2946 52.6805C22.8243 50.4268 21.0215 48.6055 18.7921 48.1348C14.9691 47.3275 11.6034 50.2564 11.6034 53.9805C11.6034 55.7733 12.3897 57.3725 13.6275 58.4657C14.0583 58.8461 14.2106 59.4539 13.9871 59.9864L13.2208 65.3153C12.8385 66.2266 11.9542 66.8187 10.9755 66.8187H6.81405C6.15166 66.8187 5.61475 67.3617 5.61475 68.0316L4.49979 70.9921C4.49979 71.662 5.03669 72.205 5.69908 72.205H29.3005C29.9629 72.205 30.4998 71.662 30.4998 70.9921L29.3005 68.0319C29.3008 67.362 28.7639 66.8187 28.1012 66.8187H24.0761ZM30.3182 73.2769H4.8604C4.53018 73.2769 4.2627 73.5474 4.2627 73.8813V75.0648C4.2627 75.3988 4.53018 75.6693 4.8604 75.6693H30.3182C30.6484 75.6693 30.9159 75.3988 30.9159 75.0648V73.8813C30.9159 73.5477 30.6484 73.2769 30.3182 73.2769Z" fill="url(#paint1_linear_18567_54224)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M36.25 11.5H38.75L40 44H35L36.25 11.5Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M59.75 40.5L59.75 43L35.25 44.25V39.25L59.75 40.5Z" fill="white"/>
            <defs>
                <linearGradient id="paint0_linear_18567_54224" x1="0" y1="0.5" x2="0" y2="76.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FD1616"/>
                <stop offset="1" stop-color="#FFFBFB"/>
                </linearGradient>
                <linearGradient id="paint1_linear_18567_54224" x1="15.6309" y1="40.8921" x2="-3.7308" y2="65.3795" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FD1616"/>
                <stop offset="1" stop-color="#FFA4A4"/>
                </linearGradient>
            </defs>
        </svg>
        <h2>我们将在1个工作日内，通知您审核结果，请您耐心等待</h2>
        <!-- <a href="/">返回首页</a> -->
        <a id="xms_online" href="?funToApp&l_id=333582#AiGuPiao_DirectMessages">联系运营专员</a>
    </div>
    <!-- 审核成功 -->
    <div class="appl_re" v-if="show_re == 'approved'">
        <h1>审核通过</h1>
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="77" viewBox="0 0 76 77" fill="none">
          <circle cx="38" cy="38.5" r="38" fill="url(#paint0_linear_20461_1137)"/>
          <path d="M24.4258 38.1978L35.4124 48.1322C35.8236 48.504 36.4589 48.4704 36.8285 48.0572L54.596 28.1935" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
          <defs>
            <linearGradient id="paint0_linear_20461_1137" x1="0" y1="0.5" x2="0" y2="76.5" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FD1616"/>
              <stop offset="1" stop-color="#FFFBFB"/>
            </linearGradient>
          </defs>
        </svg>
        <h2>恭喜您成为爱股票合作者，联系运营专员</h2>
        <a  id="yunying" href="?funToApp&l_id=333582#AiGuPiao_DirectMessages">联系运营专员</a>
    </div>
  </div>  

</template>

<script>
import colla from '@/api/collaborator/index.js'
import { Toast } from 'vant';
import { areaList } from '@vant/area-data';
import { getQueryVariable } from "@/utils/urlQuery";
export default {
    data() {
      return {
        //not_apply：未申请过、 in_review：审核中、 approved：审核通过、 failed：审核失败
        show_re:'not_apply',//默认未申请过
        //表单数据
        ruleForm: {
          name: '',
          card:'',
          contact:'',
          phone: '',
          sex: '',
          loc: '',
          other: '',
          fans_pic:[],
          id_pic:[],
          fans: '',
          vip: 'no',
          desc: ''
        },
        // ruleForm: {
        //   name: '黄虎',
        //   card:'130627200002020202',
        //   contact:'试试',
        //   phone: '' ,
        //   sex: 'man',
        //   loc: '',
        //   other: '试试',
        //   fans_pic:[{url:'https://cdncos.aigupiao.com/assets/pc/img/2023/sbid_card.png'}],
        //   id_pic:[{url:'https://cdncos.aigupiao.com/assets/pc/img/2023/sbid_card.png'}],
        //   fans: 'less_than_1w',
        //   vip: 'no',
        //   desc: '试试'
        // },
        //校验
        rules: {
          name: [
            { required: true, message: '请输入姓名', 
              },
            {
              pattern: /^[\u4E00-\u9FA5]{2,4}$/,
              message: '请输入真实姓名',
            }
          ],
          card: [
            { required: true, message: '请输入身份证号', },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '身份证号格式有误',
            }
          ],
          contact: [
            { required: true, message: '请输入微信号/qq号',  },
          ],
          phone: [
            { required: true, message: '请先绑定手机号',  }
          ],
          sex: [
            { required: true, message: '请选择性别', }
          ],
          loc: [
            { required: true, message: '请选择所在地',  }
          ],
          other: [
            { required: true, message: '请填写其他平台账号名称',  }
          ],
          fans: [
            { required: true, message: '请选择自媒体粉丝量',  }
          ],
          fans_pic: [
            { type: 'array', required: true, message: '请至少上传一张自媒账号的截图', }
          ],
          id_pic: [
            { type: 'array',required: true, message: '请上传身份信息图片', }
          ],
          vip: [
            { message: '请选择是否具备投顾资质',  }
          ],
          other: [
            { required: true, message: '请填写其他平台账号名称', }
          ],
          desc: [
            { required: true, message: '请填写个人简介',  }
          ]
        },

        agree:false,

      
        //获取省市
        value: '',
        showArea: false,
        areaList: areaList, // 数据格式见 Area 组件文档

        screenHeightNoChange:false,
      
      };
    },
    methods: {
      scrollFn(kind){
        this.screenHeightNoChange = kind;
        setTimeout(() => {
          document.documentElement.scrollTop  = 9999;
        }, 10);
        
      },
      upload(num,kind){
        this.$srH5CallNativeMethodApp('call_native_photo',{
            maxCount: num,//最多选择个数
            kind:kind,//上传种类
        })
      },
      pageToPhone(){
        this.$srH5CallNativeMethodApp('call_Native',{
            kind: 'bind_phone',//跳转到绑定手机页面
        })
      },
      handleSpecialCharacters(jsonStr) {
          let obj = {};
          if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
              jsonStr = jsonStr.replace(/\n/g, "\<br/>");
              obj = JSON.parse(jsonStr)
          }
          return obj;
      },
      // 提交表单且验证不通过后触发
      onFailed(error) {
        // error 可以打印看看，错误信息集合
        console.log(error)
        if (error.errors[0]) { // 
          Toast.fail(error.errors[0].message);
        }
      },
      onConfirm(values) {
        //选择省市
        this.value = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');
        this.showArea = false;
        this.ruleForm.loc = this.value;
      },
      onSubmit() {
          // 全局表单验证
          this.$refs['ruleForm'].validate().then(() => {
              if(!this.agree){
                //没有同意签署协议
                Toast.fail('请阅读并同意《爱股票合作者服务规范》');
              }
              else{
                this.userCollaborationApply();
              }
          }).catch(() => {
              Toast.fail('提交失败，请检查后再次提交')
          })
      },
      async getphone() {
        let res = await colla.getUserPhone({
          user_id	: this.userInfo.u_id,
          u_id:this.userInfo.u_id,
        })
        if (res.rslt == "succ") {
          if(res.data.is_bind_phone == 1){
            this.ruleForm.phone = res.data.bind_phone;
          }
        }
      },
      page(){
        //跳转协议
        let urlBase = "https://mobile.aigupiao.com";
        if (location.href.includes("dev")) {
            urlBase = "https://mobiledev.aigupiao.com";
        } else if (location.href.includes("beta")) {
            urlBase = "https://mobilebeta.aigupiao.com";
        }
        this.$igpJumpToNative('h5',`${urlBase}/up/collaborator/agree`)
      },
      async getUserCollaborationApplyState(){
        //获取申请状态
        let res = await colla.getUserCollaborationApplyState({
          user_id	: this.userInfo.u_id,
        })
        if(res.code == 1) {
              // "state": "approved"		
              //not_apply：未申请过、 in_review：审核中、 approved：审核通过、 failed：审核失败
              this.show_re = res.data && res.data.state;
          } else {
            Toast.fail(res.message);
          }
      },
      async userCollaborationApply(){
        //申请
        let arr = JSON.parse(JSON.stringify(this.ruleForm.fans_pic));
        let self_media_account_image = arr.map((item)=>{
          return item.url;
        })
        let params = {
          user_id	: this.userInfo.u_id,
          username:this.ruleForm.name,		//姓名
          id_card_no:this.ruleForm.card,			//身份证号码
          contact:this.ruleForm.contact,			//微信号/qq号
          sex:this.ruleForm.sex,					//性别 man-男、women-女
          area:this.ruleForm.loc,				//地区 省市之间用/分割，如：河北省/石家庄
          other_platform_accounts:this.ruleForm.other,		//其他平台账号
          fans_number	:this.ruleForm.fans,		//自媒体粉丝数	less_than_1w：少于1万、 more_than_1w：多余1万
          self_media_account_image:JSON.stringify(self_media_account_image) ,	//自媒体账号的截图url
          service_vip	:this.ruleForm.vip,		//是否是投顾	yes：是、no：否
          authentication_data	:this.ruleForm.id_pic[0].url,//认证资料url
          personal_profile:this.ruleForm.desc,	//个人简介
        };
        console.log('params',params)
        let res = await colla.userCollaborationApply(params);          
          if(res.code == 1) {
          //接口成功默认审核中
          this.show_re = 'in_review';
          
          } else {
            Toast.fail(res.message);
          }
      }
    },
    computed:{
      userInfo() {
        return { u_id :getQueryVariable('u_id') };
      },
    },
    created(){
      if(!this.userInfo.u_id){
        //未登录
        Toast.fail('请先登录');
      }
      else{
        //已登录获取手机号
        this.getUserCollaborationApplyState()
        this.getphone();
        //获取申请状态 成功/失败/未申请/审核中
      }
      
    },
    mounted(){
      window.srNativeCallH5Method = (data) => {
          let params = null;
          params = this.handleSpecialCharacters(data);
          if(params.method_name == 'send_photo_url') {
              //接收app传过来的图片地址数组
              let kind = params.params.kind,arr = params.params.urls;

              arr.forEach(item => {
                this.ruleForm[kind].push({
                  url:item,
                });
              });
              
          }
          else if(params.method_name == 'refresh_phone_bind') {
            this.getphone();
              
          }
           
      };

      window.testFn = (kind) => {
        //fans_pic id_pic
        this.ruleForm[kind].push({
          url:'https://cdncos.aigupiao.com/assets/pc/img/2023/sbid_card.png'
        });
      }
        
    },
}
</script>

<style lang="scss" scoped>
    .application{
      background: #fff;
        min-height: 100vh;
    }

    .appl{
        margin: 0 auto 0;
        //width: 1166px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid #DDD;
        &.appl2{
          padding-bottom: 25vh;
        }

        >h1{
            color: #EB5752;
            text-align: center;
            font-size: 22px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            display: flex;
            height: 80px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
            background: #FCEDEA;
        }
        .form_box2410{

          .border{
            background: #F5F6F7;
            height: 10px;
          }
          .boxbox{
            width: 100%;
            p{
              color: #939393;
              font-size: 13px;
              line-height: normal;
              margin-bottom: 10px;
              margin-top: 6px;
            }
            >h1{
              color: #646566;
            }
            a{
              color: #323233;
              
            }
            .alink{
                color:#ee0a24;
              }
          }


            //padding: 50px 280px;
            background: #fff;

          .img_box{
            display: flex;
            align-items: flex-end;
            .pic_ex{
              img{
                width: 106px;
                height: 80px;
                flex-shrink: 0;
              }
            }
          }


          .sb_p{
                margin: 10px 0;
                display: flex;
                align-items: center;
                cursor: pointer;
                color: #636363;
                font-size: 13px;
                >svg{
                  margin-right: 8px;
                  cursor: pointer;
                  width: 22px;
                  height: 22px;
                  margin-left: 12px;
                }
                >span{
                  color:#1D88D0;
                  cursor: pointer;
                }
              }

          .btn{
            margin: 10px 12px;
            
          }
        }
    }

    .appl_re{
        padding-top: 90px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        h1{
            color:  #333;
            text-align: center;

            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 21px; /* 116.667% */
        }
        >svg{
            margin: 35px 0 30px;
        }

        h2{
            color: #939393;
            text-align: center;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; /* 160% */
            width: 282px;

        }
        #yunying{
            display: flex;
            width: 294px;
            height: 49px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
            border-radius: 28px;
            border: 0.5px solid #FD1616;
            color: #FD1616;

            font-size: 17px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px; /* 123.529% */
            margin: 30px 0 20px;
        }
        #xms_online{
            cursor: pointer;
            color:  #1D88D0;
            text-align: center;

            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 21px; /* 150% */
            margin-bottom: 80px;
            margin-top: 15px;
        }
    }
</style>

<style lang="scss">
.form_box2410{
  .img_box{
    .van-uploader__upload{
      background-color: #fff;
      width: 200px;
      height: 125px;
      flex-shrink: 0;
      background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/sbid_card2.svg);
      background-size: cover;
      .van-uploader__upload-icon{
        display: none;
      }
    }
    .van-uploader__preview-image{
      width: 200px;
      height: 125px;
    }
  }

  .van-radio__icon .van-icon{
    background-color: unset;
    border-color:unset;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/select_w.png);
    background-size:cover;
    border: unset;
  }

  .van-radio__icon--checked .van-icon{
    background: #FF443D;
    border-color:#FF443D;

    background-color: unset;
    border-color:unset;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/select_red.png);
    background-size:cover;
  }

  .van-icon-success:before{
    content: '';
  }

  .van-button--square{
    border-radius: 4px;
  }
  .van-cell__title.van-field__label.other{
    width: 68px;
  }
  .radio_box{
    .van-field__value{
      display: flex;
    }
  }

}

</style>
